module.exports = __webpack_public_path__ + "static/c3logo-98571924b27d0517ad68488d66cd8040.png";